import React from 'react';
import {FieldHookConfig, useField} from "formik";
import {Input, InputProps} from "../Control";

// Component ----

export type InputFieldProps = InputProps & FieldHookConfig<string>

function InputField(props: InputFieldProps) {
    const [field, meta] = useField(props)

    const error = (meta.touched && !!meta.error)? meta.error : null

    return <Input error={error} {...field} {...props} />
}

export default InputField;